import { render, staticRenderFns } from "./UrbanTerzoneRegulation.vue?vue&type=template&id=7ca7e617&"
import script from "./UrbanTerzoneRegulation.vue?vue&type=script&lang=js&"
export * from "./UrbanTerzoneRegulation.vue?vue&type=script&lang=js&"
import style0 from "./UrbanTerzoneRegulation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports